import React from "react";
import NamedResourceList from "../curriculum/components/named-resource-list";
import {cvDepartmentService} from "../../services/curriculum-resource-service";

const columns = [
    {field: "name", headerName: "Nome", flex: 1},
];

const CvDepartment = () => (
    <NamedResourceList title="Departamentos" newLabel="Novo departamento" basePath="/cv/department"
                       queryKey="cv-departments" service={cvDepartmentService} columns={columns}/>
);

export default CvDepartment;
